module.exports = __webpack_public_path__ + "static/media/chicago_edited.6692447e.jpg";